import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'hfs-common-ui';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import * as S from '../AddMachineContainer/styled';
import { AppState } from '~/reducers';
export interface Props {
  onClick?(): void;
  iconText?: string;
  id?: string;
}

const BackButton = ({ onClick, iconText, id }: Props) => {
  const platform = useSelector((state: AppState) => state.native.nativeAppInfo?.platform);
  return (
    <S.BackButtonWrapper tabIndex={-1} id={id}>
      <Button
        icon={{
          position: 'left',
          type: platform === 'Android' ? 'android.android_arrow_back' : 'action.arrow_left',
        }}
        variant="surface"
        size="medium"
        customStyle={{
          backgroundColor: 'transparent',
          color: 'gray600',
        }}
        onClick={onClick}
      >
        {' '}
        {iconText && <S.TextWrapper>{formatMessageWrapper(iconText)}</S.TextWrapper>}
      </Button>
    </S.BackButtonWrapper>
  );
};

export default React.memo(BackButton);
